module.exports = __webpack_public_path__ + "static/img/oil1.afdf1be1.png";